"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductNavComponent = void 0;
exports.default = ProductNavWrapper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactMintl = require("@godaddy/react-mintl");
var _util = require("@ux/util");
var _mobileNav = _interopRequireDefault(require("@ux/mobile-nav"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _componentUtilities = require("@ux/component-utilities");
var _enums = require("./enums");
var _utils = require("./utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Render and expose the Product navigation as a Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced Product Nav.
 * @public
 */
class ProductNavComponent extends _react.Component {
  constructor(props) {
    super(...arguments);
    this.state = _objectSpread({}, this.nextStateFromProps(props));
  }

  /**
   * Initialize current href and active heading.
   *
   * @param {Object} props received
   * @returns {Object} Object containing currentHref and activeHeading
   * @private
   */
  nextStateFromProps(props) {
    let {
      currentHref,
      activeCaption
    } = props;
    if (typeof document !== 'undefined' && !currentHref) {
      activeCaption = window.sessionStorage.getItem('activeCaption');
      currentHref = document.location.href;
    }
    if (currentHref) {
      const currentUrl = new _util.URL(currentHref, true);
      const qsCurrentHref = currentUrl.query.currentPage;
      if (qsCurrentHref) {
        currentHref = qsCurrentHref;
      } else {
        currentHref = currentUrl.href;
      }
    }
    const active = this.findParent({
      url: currentHref,
      id: activeCaption,
      items: props.navigation,
      firstMatch: false
    });
    return {
      currentHref,
      activeHeading: active && active.activeHeading
    };
  }

  /**
   * Perform a recursive search through the navs data structure looking for
   * the specific URL and title. When found return the parent object that contains it
   * so we can get all of it's sibling links.
   *
   * @param {Object} opts Options for findParent
   * @param {String} opts.url The url to match against
   * @param {String} opts.id The title to check against
   * @param {Object[]} opts.items The child items for which to find the parent
   * @param {Object} opts.firstMatch The parent object containing the first matching url
   * @param {Object} [opts.parent] The parent returned from the previous call to findParent
   *
   * @returns {Object} Parent object containing url
   * @private
   */
  // eslint-disable-next-line complexity, max-statements
  findParent(opts) {
    const {
      url,
      id,
      items,
      parent
    } = opts;
    let {
      firstMatch
    } = opts;
    if (!url || !items) {
      return;
    }
    if (Array.isArray(items)) {
      for (let i = 0, len = items.length; i < len; i++) {
        const result = this.findParent({
          url,
          id,
          items: items[i],
          firstMatch,
          parent
        });
        if (result) {
          if (result.isFullMatch) {
            return result;
          }
          if (i === len - 1) {
            return result;
          } else if (!firstMatch) {
            firstMatch = result.activeHeading;
          }
        }
      }
    } else {
      if (items.href && (0, _utils.urlMatches)(url, items.href, true)) {
        // save the first url match in case there is no match
        if (!firstMatch) {
          firstMatch = parent || items;
        }
        if (!id || id === items.id) {
          return {
            isFullMatch: true,
            activeHeading: parent || items
          };
        }
      }
      if (items.children) {
        return this.findParent({
          url,
          id,
          items: items.children,
          firstMatch,
          parent: items
        });
      }
      if (firstMatch) {
        return {
          isFullMatch: false,
          activeHeading: firstMatch
        };
      }
    }
  }

  /**
   * Build the primary navigation links from the passed in nav data structure.
   *
   * @returns {Array} nav items
   * @private
   */
  buildMainNav() {
    const {
      props
    } = this;
    const navs = [];
    props.navigation.forEach(item => {
      if (item.title) {
        if (item.children || item.href) {
          if (!item.onlyMobile) {
            navs.push(item);
          }
        }
      }
    });
    return (0, _utils.trayMenusBuilder)(navs, {
      urlArgs: props.urlArgs,
      className: 'topnav-item',
      classes: {
        isPro: 'flag-pro',
        isFree: 'flag-free',
        isNew: 'flag-new',
        onSale: 'flag-sale',
        tout: 'flag-sale',
        productTitle: 'product-title'
      }
    });
  }

  /**
   * Build the primary navigation links to be displayed on the right side
   * of the header.
   *
   * @param {String} navRightClassName class name for the right navigation
   * @returns {Array} nav items
   * @private
   */
  buildNavRight(navRightClassName) {
    const {
      props
    } = this;
    if (!props.navigationRight) {
      return null;
    }

    // navigationRight can have links or menus
    return (0, _utils.trayMenusBuilder)(props.navigationRight, {
      className: (0, _classnames.default)(navRightClassName, 'topnav-item'),
      classes: {
        isPro: 'flag-pro',
        isFree: 'flag-free',
        isNew: 'flag-new',
        onSale: 'flag-sale',
        tout: 'flag-sale',
        productTitle: 'product-title'
      },
      eidPrefix: 'uxp.hyd.product_nav',
      urlArgs: props.urlArgs
    });
  }

  /**
   * Build the secondary navigation links from the passed in nav data structure.
   *
   * @param {number} category index of selected primary nav
   * @returns {Array} nav items
   * @private
   */
  // eslint-disable-next-line max-statements, complexity
  buildSecondaryNav() {
    const {
      props,
      state
    } = this;
    const {
      activeHeading: data,
      currentHref
    } = state;
    let active;
    if (!data || !data.children) {
      return [];
    }

    // determine which child link is active
    for (let i = 0; i < data.children.length; i++) {
      const item = data.children[i];
      if ((0, _utils.urlMatches)(currentHref, item.href, true)) {
        if (item.options && item.options.hideSecondaryNav) {
          return [];
        }
        active = item.id;
      }
    }
    const subnav = (0, _utils.linkListBuilder)(data.children, {
      className: 'secondarynav-item',
      activeClass: 'active',
      active,
      eidPrefix: 'uxp.hyd.secondary_nav',
      urlArgs: props.urlArgs
    });
    const {
      title,
      id
    } = data;
    if (title) {
      subnav.unshift( /*#__PURE__*/_react.default.createElement("li", {
        key: title,
        id: id,
        className: "secondarynav-item"
      }, title));
    }
    return subnav;
  }

  /**
   * Renders the desktop primary & secondary navigation
   *
   * @returns {ReactElement} the desktop nav
   * @private
   */
  renderDesktop() {
    return /*#__PURE__*/_react.default.createElement("section", null, this.renderDesktopPrimaryNav(), this.renderDesktopSecondaryNav());
  }

  /**
   * Renders the desktop primary navigation
   *
   * @returns {ReactElement} primary navigation
   * @private
   */
  renderDesktopPrimaryNav() {
    const {
      props
    } = this;
    if (!props.showPrimaryNav) {
      return null;
    }
    const topNavList = this.buildMainNav();
    const navRight = this.buildNavRight();
    return /*#__PURE__*/_react.default.createElement("nav", {
      className: "topnav reseller"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-nav-container",
      ref: r => {
        this.topNav = r;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-nav-row"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "topnav-items",
      ref: r => {
        this.topNavItems = r;
      }
    }, topNavList), /*#__PURE__*/_react.default.createElement("ul", {
      className: "topnav-right"
    }, navRight))));
  }

  /**
   * Renders the desktop secondary navigation
   *
   * @returns {ReactElement} secondary navigation
   * @private
   */
  renderDesktopSecondaryNav() {
    const secondaryNavList = this.buildSecondaryNav();
    if (!secondaryNavList.length) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("nav", {
      className: "secondarynav"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-nav-container",
      ref: r => {
        this.secondaryNav = r;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-nav-flex"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("ul", {
      className: "secondarynav-items",
      ref: r => {
        this.secondaryNavItems = r;
      }
    }, secondaryNavList)))));
  }

  /**
   * Renders the mobile navigation
   *
   * @returns {ReactElement} mobile navigation
   * @private
   */
  renderMobile() {
    const {
      state,
      props
    } = this;
    if (!props.showPrimaryNav) {
      return null;
    }
    const navs = [];
    const navRight = this.buildNavRight('topnav-promos-link-mobile');
    props.navigation.forEach(item => {
      // convert `leftnav` to `href` to match expected data structure of `@ux/mobile-nav`
      if (item.leftnav && item.leftnav.href) {
        if (!item.href) {
          item.href = item.leftnav.href;
        }
      }
      if (item.title) {
        navs.push(item);
      }
    });
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("nav", {
      className: (0, _classnames.default)('topnav', 'reseller'),
      style: {
        overflow: 'visible'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-nav-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-nav-row"
    }, /*#__PURE__*/_react.default.createElement(_mobileNav.default, {
      nav: navs,
      menuTitle: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: _enums.golf.allProducts
      }),
      market: props.market,
      messages: props.messages,
      urls: props.urls,
      currentHref: state.currentHref,
      activeHeading: state.activeHeading,
      showHomeLink: props.isReseller,
      eidPrefix: "uxp.hyd.product_nav",
      urlArgs: props.urlArgs,
      menuButtonEid: 'uxp.hyd.all_products_menu_open.button.click'
    }), /*#__PURE__*/_react.default.createElement("ul", {
      className: "mobile-nav-right"
    }, navRight)))));
  }

  /**
   * Renders complete nav.
   *
   * @returns {ReactElement} The rendered header
   * @private
   */
  render() {
    const {
      props
    } = this;
    let content = null;
    if ((0, _componentUtilities.isMobile)(props.breakpoint) || props.breakpoint === 'tablet') {
      content = this.renderMobile();
    } else {
      content = this.renderDesktop();
    }
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "top"
    }, content));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
exports.ProductNavComponent = ProductNavComponent;
ProductNavComponent.propTypes = {
  currentHref: _propTypes.default.string,
  market: _propTypes.default.string,
  messages: _propTypes.default.object.isRequired,
  navigation: _propTypes.default.array.isRequired,
  navigationRight: _propTypes.default.array,
  showPrimaryNav: _propTypes.default.bool,
  showCountryNameOnLogo: _propTypes.default.bool,
  specialNav: _propTypes.default.array,
  sticky: _propTypes.default.object,
  isReseller: _propTypes.default.bool,
  urlArgs: _propTypes.default.object,
  urls: _propTypes.default.object,
  breakpoint: _propTypes.default.string.isRequired
};

/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */
ProductNavComponent.defaultProps = {
  country: '',
  currentHref: '',
  market: 'en-US',
  navigationRight: [],
  showCountryNameOnLogo: true,
  showPrimaryNav: true,
  isReseller: false
};
function ProductNavWrapper(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)(..._enums.breakpoints);
  return /*#__PURE__*/_react.default.createElement(ProductNavComponent, (0, _extends2.default)({
    breakpoint: breakpoint
  }, props));
}